import RoutesEnum from 'enums/routes.enum'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'

export default [
    {
        path: '/rating/rate',
        name: RoutesEnum.RATING.RATE,
        view: 'rating/Rating',
        middlewares: [RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Ocenjivanje | Bookeraj',
            description:
                'Oceni proizvode, usluge ili sadržaj na našoj platformi. Podeli svoje mišljenje i pomogni drugim korisnicima da pronađu najbolje opcije.',
        },
    },
]
